/**
 * Created by why on 2019/12/23.
 */
import {
  getNotepadByCondition,
  notepadSave,
  notepadEdit,
  notepadDelByIds,
  getById
} from '@/api/notepad-manage'

export default {
  state: {
    list: [],
    notepadLoading: false,
    loadingSave: false,
    pageSize: 10,
    pageNum: 1,
    total: 0
  },
  mutations: {
    setNotepadList (state, list) {
      state.list = list
    },
    setNotepadLoading (state, loading) {
      state.notepadLoading = loading
    },
    setNotepadPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setNotepadPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setNotepadTotal (state, total) {
      state.total = total
    },
    setNotepadLoadingSave (state, loadingSave) {
      state.loadingSave = loadingSave
    }
  },
  getters: {
    notepadList: state => state.list,
    notepadTotal: state => state.total,
    notepadLoading: state => state.notepadLoading,
    notepadLoadingSave: state => state.loadingSave
  },
  actions: {
    getNotepadByCondition ({ state, commit }, data) {
      commit('setNotepadLoading', true)
      return new Promise((resolve, reject) => {
        getNotepadByCondition(data).then(res => {
          const data = res.data.result
          const list = data.records
          const pageSize = data.pageSize
          const pageNum = data.pageNum
          const total = data.total
          commit('setNotepadList', list)
          commit('setNotepadLoading', false)
          commit('setNotepadPageSize', pageSize)
          commit('setNotepadPageNum', pageNum)
          commit('setNotepadTotal', total)
          resolve(res)
        }).catch(err => {
          commit('setNotepadLoading', false)
          reject(err)
        })
      })
    },
    notepadSave ({ state, commit }, data) {
      commit('setNotepadLoadingSave', true)
      return new Promise((resolve, reject) => {
        notepadSave(data).then(res => {
          commit('setNotepadLoadingSave', false)
          resolve(res)
        }).catch(err => {
          commit('setNotepadLoadingSave', false)
          reject(err)
        })
      })
    },
    notepadDelByIds ({ state, commit }, ids) {
      return new Promise((resolve, reject) => {
        notepadDelByIds(ids).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    notepadEdit ({ state, commit }, data) {
      commit('setNotepadLoadingSave', true)
      return new Promise((resolve, reject) => {
        notepadEdit(data).then(res => {
          commit('setNotepadLoadingSave', false)
          resolve(res)
        }).catch(err => {
          commit('setNotepadLoadingSave', false)
          reject(err)
        })
      })
    },
    getNotepadById ({ state, commit }, id) {
      return new Promise((resolve, reject) => {
        getById(id).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/notepad-manage.js